module.exports = __webpack_public_path__ + "img/population.6bdfef67.svg";